<div class="sugList" *ngIf="profiles.length > 0 && newFollow">
  <p class="sugList__title vc-text-s" i18n="@@FEED.SUGGESTION.SUGG_PROFILE">
    Suggested Profiles
  </p>
  <div class="sugList__slider">
    <ng-container *ngFor="let profile of profiles; let index = index">
      <vc-feed-suggestions-profile
        class="sugList__slider__item"
        [profile]="profile"
        (hideProfileSuggestion)="hideProfileSuggestion($event)"
        (onFollow)="onFollowProfile.emit($event)"
        (onSeeProfile)="onSeeProfile.emit($event)"
      ></vc-feed-suggestions-profile>
    </ng-container>
  </div>
</div>
